/** Visible labels for `<option>` elements — values stay snake_case for the API. */

export const WRITE_MODE_LABELS: Record<
  "replace_snapshot" | "append" | "merge" | "merge_history",
  string
> = {
  replace_snapshot: "Snapshot",
  append: "Append",
  // ADR-0094: new write mode — key-required, overwrite on conflict
  merge: "Merge",
  merge_history: "Merge history",
};

/** Human-readable write mode for tables and summaries (API / stored values stay snake_case). */
export function writeModeDisplayLabel(mode: string | null | undefined): string {
  if (mode == null || mode === "") return "—";
  const label = WRITE_MODE_LABELS[mode as keyof typeof WRITE_MODE_LABELS];
  return label ?? mode;
}

/** One-line policy description shown under the write-mode picker. */
export const WRITE_MODE_DESCRIPTIONS: Record<
  "replace_snapshot" | "append" | "merge" | "merge_history",
  string
> = {
  replace_snapshot: "Every run replaces the prior version. No key required.",
  append: "New keys are inserted; rows whose key already exists are skipped.",
  merge: "New keys are inserted; rows whose key already exists are overwritten.",
  merge_history:
    "Slowly-changing dimension. Closes the prior row and inserts a new one on meaningful change.",
};

export const MISSING_ROW_POLICY_LABELS: Record<"ignore_missing" | "close_on_missing", string> = {
  ignore_missing: "Ignore missing",
  close_on_missing: "Close on missing",
};

/** ADR-0094: discriminated within-batch duplicate handling. */
export const WITHIN_BATCH_DUP_MODE_LABELS: Record<"error" | "keep_one", string> = {
  error: "Error (fail the run)",
  keep_one: "Keep one",
};

export const SURVIVOR_LABELS: Record<"highest" | "lowest", string> = {
  highest: "Keep highest value",
  lowest: "Keep lowest value",
};

/** ADR-0100: business_time.fallback options on merge_history. */
export const BUSINESS_TIME_FALLBACK_LABELS: Record<"system_time" | "reject", string> = {
  system_time: "Use system time",
  reject: "Reject",
};

/** ADR-0100: top-level duplicate-key-handling discriminator. */
export const DUP_HANDLING_LABELS: Record<"error" | "keep_one", string> = {
  error: "Error on duplicates",
  keep_one: "Keep one",
};

/** persistent_provider read_mode */
export const PDO_READ_MODE_LABELS: Record<"current" | "version" | "as_of_business" | "as_of_system" | "history", string> = {
  current: "Current",
  version: "Version",
  as_of_business: "As of business time",
  as_of_system: "As of system time",
  history: "History — every kept report run",
};
